<template>
	<div class="product-details-not-found">
		<div class="product-details-not-found-holder">
			<img
				class="product-details-not-found-image"
				src="../../assets/images/placeholder_nodetails.svg"
				alt=""
			/>
			<span class="product-details-not-found-message">
				SOMETHING WENT WRONG
			</span>
			<div class="product-details-not-found-description">
				<p>SmartTab functionality is not available at this moment ...</p>
			</div>

			<span v-if="!isIncorrectId" class="button" @click="getProductDetails">
				Retry
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ProductDetailsNotFound',

	props: {
		isIncorrectId: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		getProductDetails() {
			this.$emit('get-product-details')
		}
	}
}
</script>

<style lang="scss">
.product-details-not-found {
	height: 100%;
	white-space: nowrap;
	text-align: center;
	color: #9b9b9b;
	background: #2c2a35;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	position: relative;
	z-index: 100;

	&:after {
		display: inline-block;
		vertical-align: middle;
		height: 100%;
		width: 0;
		content: '';
	}

	.button {
		min-width: 136px;
		margin: 0 0 48px;
	}
}

.product-details-not-found-holder {
	display: inline-block;
	vertical-align: middle;
	white-space: normal;
}

.product-details-not-found-image {
	display: block;
	margin: 0 auto 26px;
	vertical-align: top;
}

.product-details-not-found-message {
	display: inline-block;
	padding: 0 5px 5px;
	margin: 0 0 6px;
	font-size: 16px;
	font-weight: 700;
	color: #816cc2;
	border-bottom: 1px solid #816cc2;
}

.product-details-not-found-description {
	padding: 0 40px 18px;

	p {
		margin: 0;
	}
}
</style>
